import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { PropertyLeadProfile } from './property-lead-profile';
import { SharedService } from './../_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class PropertyLeadProfileService {

	propertyTypes: any = [
		{ value: '01', name: 'Condo' },
		{ value: '16', name: 'Townhome' },
		{ value: '14', name: 'House' }
	];

	listingStatuses = [
		{ value: 1, name: 'YES', color: 'lightgreen' },
		{ value: 0, name: 'NO', color: 'lightcoral' },
		{ value: 2, name: 'OWNER', color: 'lightblue' },
	]

	ownersList: any = [
		{ value: '1', name: 'Primary' },
		{ value: '2', name: 'Vacation' },
		{ value: '3', name: 'Investment' }
	];

		targetPriorities = [
			{ value: "", name: "" },
			{ name: '0 (Never)', value: 0 },
			{ name: '1 (Low)', value: 1 },
			{ name: '2 (Low-Med)', value: 2 },
			{ name: '3 (Med)', value: 3 },
			{ name: '4 (Med-High)', value: 4 },
			{ name: '5 (High)', value: 5 }
	];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService,
		) { }

	urlEndpoint = 'property-lead-profiles';

	add(propertyLeadProfile: PropertyLeadProfile): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(propertyLeadProfile));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, propertyLeadProfile);
	}

	update(propertyLeadProfile: PropertyLeadProfile): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, propertyLeadProfile);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByOwner(ownerLeadProfileId: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-by-owner/${ownerLeadProfileId}`);
	}

	fastSearch(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/fast-search`).pipe();
	}

	getFilterData(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/filterData`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	search(name: string) {
		// return this.http.get<ApiResponse>(`${ environment.apiUrl }/${ this.urlEndpoint }?name=${name}`).pipe(retry({ count: 2, delay: 1500 }));

		return this.http.get<any>(`${environment.apiUrl}/property-lead-profiles/property-lead-detail-search?name=${name}`)
			.toPromise()
			.then(res => <any>res.data)
			.then(data => { return data; });
	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	bulkUpdate(propertyLeadProfiles: any[]): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/bulk-update`, propertyLeadProfiles);
	}
}


